/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_OpenInputs */

const en_filter_is_open = /** @type {(inputs: Filter_Is_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`open`)
};

const de_filter_is_open = /** @type {(inputs: Filter_Is_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`offen`)
};

/**
* | output |
* | --- |
* | "open" |
*
* @param {Filter_Is_OpenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_open = /** @type {((inputs?: Filter_Is_OpenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_OpenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_open(inputs)
	return en_filter_is_open(inputs)
});